import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/internship-applications', config);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/internship-applications/excel-export', {
        ...config,
        responseType: 'blob'
    });
};

const updateStatus = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/coop/internship-applications/' + id + '/status', data);
};

const updateDocumentStatus = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/coop/internship-applications/' + id + '/documents-status', data);
};

const showDocument = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/internship-applications/' + id + '/show-document', data, {
        responseType: 'blob'
    });
};

const remove = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/coop/internship-applications/' + id);
};

const apply = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/internship-postings/' + id + '/apply', data);
};

const getMe = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/internship-applications/me', config);
};

const uploadDocument = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    return Api.post('/coop/internship-applications/' + id + '/upload-document', formData, config);
};

const submitDocuments = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/internship-applications/' + id + '/submit-documents');
};

export default {
    getAll,
    excelExport,
    updateStatus,
    updateDocumentStatus,
    showDocument,
    remove,
    apply,
    getMe,
    uploadDocument,
    submitDocuments
};
